import type { ScreenEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject } from '../new-analytics-types';

export const unifiedUserProfileEvents = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/CLOUDADMIN/pages/5144024035/Analytics+Spec+UP+M1.5',
  screen: {
    // unifiedUserProfileScreen attributes will always be defined when calling through the ScreenEventSender component when checking for isDataLoading
    unifiedUserProfileScreen: (attributes?: { userId: string; status: string | undefined; accountTag: string }): ScreenEvent => ({
      data: {
        name: 'unifiedUserProfileScreen',
        attributes: {
          userId: attributes?.userId ?? '',
          userStatus: attributes?.status ?? '',
          userType: attributes?.accountTag ?? '',
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/82953',
    }),
  },
  ui: {
    unifiedUserProfileTab: (attributes: { tabID: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.NavigationItem,
        actionSubjectId: 'unifiedUserProfileTab',
        source: 'unifiedUserProfileScreen',
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/82955',
    }),
  },
};
